import React, { useEffect } from 'react';
import Button from '../../../components/button/Button';
import title from '../../../assets/webp-images/challenge-lessons-title.png';
import creative from '../../../assets/webp-images/challenge-lessons-creative.png';
import { Mixpanel } from '../../../analytics/Mixpanel';

type Props = {
	onContinue: () => void;
};

const ChallengeObLessons: React.FC<Props> = ({ onContinue }) => {
	const onContinueTap = () => {
		Mixpanel.track('onboarding_questionnaire_info', {
			event_action: 'clicked',
			page_heading: '4 key lessons for beginners',
			event_page: 'onboarding_questionnaire_info',
			onboarding_experiment_key: 'challenge',
		});
		onContinue();
	};

	useEffect(() => {
		Mixpanel.track('onboarding_questionnaire_info', {
			event_action: 'viewed',
			page_heading: '4 key lessons for beginners',
			event_page: 'onboarding_questionnaire_info',
			onboarding_experiment_key: 'challenge',
		});
	}, []);

	return (
		<div>
			<img src={title} style={{ width: '100%', marginTop: '16px' }} alt='' />
			<img
				src={creative}
				style={{ width: '100%', marginTop: '16px', borderRadius: '12px' }}
				alt=''
			/>
			<Button
				isSticky={true}
				style={{
					alignSelf: 'center',
					marginBottom: '24px',
					width: 'calc(100% - 56px)',
					background:
						'var(--Primary_Gradient, linear-gradient(106deg, #4462EF 32.65%, #1B3DD8 105.18%))',
				}}
				onClick={onContinueTap}
				label={'Continue'}></Button>
		</div>
	);
};

export default ChallengeObLessons;
